<template>
  <b-button
    :variant="active ? 'branded' : 'link'"
    :size="size"
    :href="href"
    :class="`${className} ${active ? '' : 'text-branded'}`"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <i class="fa fa-fw fa-shopping-cart"></i>
    <sup v-if="!!invoice">
      <b-badge :variant="invoice.status == 'finalized' || !!timer && !timer.expired ? 'success' : 'danger'" pill v-if="itemCount > 0">
        {{ itemCount }}
      </b-badge>
    </sup>
    <span v-if="!!invoice && invoice.status != 'finalized' && !!timer" :class="`ml-2 ${timer.expired ? 'text-danger' : ''}`">
      {{ timer.text }}
    </span>
    <span v-if="!!invoice && invoice.status == 'finalized'" class="text-success">
      {{ trans(invoice.balance == 0 ? 'paid' : 'reserved') }}
    </span>
  </b-button>
</template>

<script>
  export default {
    props: {
      organization: Object,
      invoice: Object,
      size: {
        type: String,
        default: 'md',
      },
      href: String,
      active: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      className: String,
    },
    data() {
      return {
        trans: trans,
        seconds: null,
        timerInterval: null,
      }
    },
    computed: {
      itemCount() {
        if (!this.invoice) return 0
        return this.invoice.top_invoice_item_count
      },
      timer() {
        if (!this.invoice || !this.invoice.is_viable_cart) return null
        return _.buildCartTimer(this.seconds)
      },
    },
    watch: {
      invoice() {
        this.updateTimer()
      },
    },
    methods: {
      updateTimer() {
        this.seconds = this.invoice.status == 'expired' ? 0 : moment(this.invoice.expired_at).diff(moment(), 'seconds')
        if (this.seconds == 0 && this.timerInterval) {
          this.clearTimer()
        } else if (this.seconds > 0 && !this.timerInterval) {
          this.timerInterval = setInterval(this.updateTimer, 1000)
        }
      },
      clearTimer() {
        if (this.timerInterval) clearInterval(this.timerInterval)
        this.timerInterval = null
      },
    },
    mounted() {
      window.cartButton = this
      if (this.invoice) this.updateTimer()
    },
    destroyed() {
      this.clearTimer()
    },
  }
</script>